<script>
import TablePage from '../../../../../components/table_page';
import request from '../../../../../utils/request';
import Form from './form';

export default {
  name: 'table-component',
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      requestUrl: '/sfa/sfaActivityExecutionController/list',
      /** @desc 表单配置参数 */
      formConfig: {},
      /** @desc 请假参数配置 */
      formData: {
        year: '',
      },
      /** @desc 弹窗配置参数 */
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
      options: [],
      /** @desc 搜索框绑定数据 */
      searchFormData: {},
    };
  },
  async created() {
    await this.getConfigList('sfa_activity_task');
  },
  methods: {
    cellClick({ row, column }) {
      if (column.property === 'activityCode') {
        this.formConfig = {
          type: 'view',
          id: row.id,
        };
        this.modalConfig.title = '查看';
        this.openFull();
      }
    },
    modalClick({ val, row }) {
      let urls = '';
      let text = '';
      if (val.code === 'add') {
        this.formConfig.type = val.code;
        this.openFull();
      } else if (val.code === 'edit') {
        this.formConfig.type = val.code;
        this.formConfig.id = row.id;
        this.modalConfig.title = '编辑';
        this.openFull();
      } else if (val.code === 'enable') {
        urls = '/sfa/sfaActivityExecutionController/enable';
        text = '启用';
        this.operationClick(urls, text);
      } else if (val.code === 'disable') {
        urls = '/sfa/sfaActivityExecutionController/disable';
        text = '禁用';
        this.operationClick(urls, text);
      }
    },
    operationClick(urls, text) {
      let datas = [];
      if (this.selection.length > 0) {
        datas = this.selection;
        request.post(urls, datas).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: `${text}成功`,
            });
            this.selection = [];
            this.getList();
          }
        });
      } else {
        this.$message({
          type: 'error',
          message: '请选择数据',
        });
      }
    },
  },
};
</script>
